/* eslint-disable react/prop-types */
/* eslint-disable arrow-body-style */
import { Box, FormControl, FormLabel, Stack, Typography, TextField, Button } from '@mui/material';
import React from 'react';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { useDispatch } from 'react-redux';
import randomkey from '../../helpers/randomKey';
import { deleteLoader, setLoader } from '../../feature/Loader/LoaderSlice';
import SessionService from '../../Services/SessionService';
import { setAlert } from '../../feature/Alert/AlertSlice';
import alertMock from '../../_mock/alert';

const CreateUnderAdmin = ({ handleClose }) => {
  const phoneRegExp =
    /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
  const dispatch = useDispatch();
  const loaderKey = randomkey();
  const initialValues = {
    managerName: '',
    email: '',
    phone: '',
  };

  const validationSchema = yup.object({
    email: yup.string('Enter your email').email('Enter a valid email').required('Email is required'),
    managerName: yup.string('Ce champ doit être en chaîne de caractères').required('Ce champ est obligatoire'),
    phone: yup.string().matches(phoneRegExp, "le numéro de téléphone n'est pas valide"),
  });

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: (values) => handleClick(values),
  });

  const handleClick = (values) => {
    dispatch(setLoader({ key: loaderKey }));
    SessionService.CreateUnderAdmin(values)
      .then((values) => {
        dispatch(deleteLoader({ key: loaderKey }));
        const errorStatus = values.data.error;
        const { data } = values.data;
        if (errorStatus === false) {
          dispatch(setAlert({ state: 'success', message: data, time: 15000 }));
          handleClose();
        } else {
          dispatch(
            setAlert({ state: 'error', message: alertMock.errorServeur, secondMessage: alertMock.errorServeurSecond })
          );
        }
      })
      .catch((error) => {
        dispatch(deleteLoader({ key: loaderKey }));
        if ([404, 401, 500].includes(parseInt(error.response.status, 10))) {
          if (error.response.data.error === true) {
            dispatch(setAlert({ state: 'error', message: error?.response?.data.message }));
          }
        } else {
          dispatch(
            setAlert({ state: 'error', message: alertMock.errorServeur, secondMessage: alertMock.errorServeurSecond })
          );
        }
      });
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Typography variant="h4" sx={{ marginBottom: '10px' }}>
        Formulaire de création d'un sous-administrateur
      </Typography>
      <Box>
        <Typography variant="h5" sx={{ mb: 2, mt: 3 }}>
          Les informations du sous-administrateur
        </Typography>
        <Typography variant="h6" sx={{ mb: 5 }}>
        Entrez les informations nécessaires à la création d'un sous-administrateur pour votre établissement de crédit-bail.
          <span style={{ color: 'red' }}> *</span>
        </Typography>
        <Stack
          direction={'row'}
          justifyContent={'space-between'}
          alignItems="flex-start"
          sx={{ width: '100%', margin: '5vh auto auto auto ', flexWrap: 'wrap', rowGap: '20px' }}
          component={'form'}
          onSubmit={formik.handleSubmit}
        >
          {' '}
          <FormControl sx={{ width: { xs: '100%', md: '47.5%' } }}>
            <FormLabel>Veuillez indiquer le nom et prénom du responsable</FormLabel>
            <TextField
              id="managerName"
              name="managerName"
              value={formik.values.managerName}
              onChange={formik.handleChange}
              error={formik.touched.managerName && Boolean(formik.errors.managerName)}
              helperText={formik.touched.managerName && formik.errors.managerName}
              required
            />
          </FormControl>
          <FormControl sx={{ width: { xs: '100%', md: '47.5%' } }}>
            <FormLabel>Veuillez entrer Votre e-mail</FormLabel>
            <TextField
              id="email"
              name="email"
              value={formik.values.email}
              onChange={formik.handleChange}
              error={formik.touched.email && Boolean(formik.errors.email)}
              helperText={formik.touched.email && formik.errors.email}
              type="email"
              required
            />
          </FormControl>
          <FormControl sx={{ width: { xs: '100%', md: '47.5%' } }}>
            <FormLabel>Veuillez saisir votre numero de telephone</FormLabel>
            <TextField
              id="phone"
              name="phone"
              value={formik.values.phone}
              onChange={formik.handleChange}
              error={formik.touched.phone && Boolean(formik.errors.phone)}
              helperText={formik.touched.phone && formik.errors.phone}
              required
              type={'tel'}
            />
          </FormControl>
          <Button variant="contained" sx={{ width: '100%' }} type="submit">
            Soumettre
          </Button>
        </Stack>
      </Box>
    </Box>
  );
};

export default CreateUnderAdmin;
